<template>
  <div class="col-lg-12 col-md-12 col-sm-12" style="padding: 0">
    <div class="card">
      <div class="body">
        <div class="row clearfix">
          <div class="col-md-12 col-lg-12">
            <div
              class="panel-group"
              id="accordion_1"
              role="tablist"
              aria-multiselectable="true"
              v-for="(auth, index) in menus.viewFile"
              v-bind:key="auth"
            >
              <div class="panel panel-primary" @click="changeStatus(index)">
                <div class="panel-heading" role="tab" id="headingOne_1">
                  <h4 class="panel-title">
                    <a
                      role="button"
                      data-toggle="collapse"
                      data-parent="#accordion_1"
                      href="javascript:void(0)"
                      aria-expanded="true"
                      aria-controls="collapseOne_1"
                    >
                      <span>{{ index + 1 }}단계 </span
                      >{{ menus.koreanText[index] }}
                    </a>
                  </h4>
                </div>
              </div>

              <div
                class="panel-collapse collapse in"
                :class="[whichStep[index] == true ? 'show' : '']"
                role="tabpanel"
                aria-labelledby="headingOne_1"
              >
                <div class="panel-body">
                  <menu-tab-component v-bind:is="menus.viewFile[index]" />
                  <!-- <dev-auth-input-fields /> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--    <div-->
    <!--      class="modal"-->
    <!--      :class="{ fade: modalClick, show: modalClick }"-->
    <!--      id="defaultModal"-->
    <!--      tabindex="-1"-->
    <!--      role="dialog"-->
    <!--    >-->
    <!--      <div class="modal-dialog" role="document">-->
    <!--        <div class="modal-content">-->
    <!--          <div class="modal-header">-->
    <!--            <h4 class="title" id="defaultModalLabel">-->
    <!--              계정에 접근하도록 허용하겠습니까?-->
    <!--            </h4>-->
    <!--          </div>-->
    <!--          <div class="modal-body" style="max-height: 1000px; overflow: scroll">-->
    <!--            <div class="row clearfix">-->
    <!--              <div class="col-lg-12 col-md-12 col-sm-12">-->
    <!--                <div-->
    <!--                  class="body"-->
    <!--                  v-for="(form, index) in forms"-->
    <!--                  v-bind:key="index"-->
    <!--                >-->
    <!--                  <h6 class="card-inside-title">{{ form.key }}</h6>-->
    <!--                  <div class="row clearfix">-->
    <!--                    <div class="col-sm-12">-->
    <!--                      <div class="form-group">-->
    <!--                        <input-->
    <!--                          type="text"-->
    <!--                          class="form-control"-->
    <!--                          v-model="form.value"-->
    <!--                        />-->
    <!--                      </div>-->
    <!--                    </div>-->
    <!--                  </div>-->
    <!--                </div>-->
    <!--              </div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--          <div class="modal-footer">-->
    <!--            <button-->
    <!--              type="button"-->
    <!--              class="btn btn-primary waves-effect"-->
    <!--              @click="cloneSave"-->
    <!--              :disabled="modalDisabled"-->
    <!--            >-->
    <!--              네-->
    <!--            </button>-->
    <!--            <button-->
    <!--              type="button"-->
    <!--              class="btn btn-default btn-simple waves-effect"-->
    <!--              data-dismiss="modal"-->
    <!--              @click="closeModal"-->
    <!--            >-->
    <!--              아니오-->
    <!--            </button>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>

<script>
import eventbus from "@/store/modules/devEventBus";
export default {
  name: 'DevAuthSetting',
  props: ["menuType"],
  components: {
    DevAuthInputFields: () => import("@/views/dev/auth/DevAuthInputFields"),
    DevAuthInputTestRequest: () =>
      import("@/views/dev/auth/DevAuthInputTestRequest"),
    DevAuthInputTest: () => import("@/views/dev/auth/DevAuthInputTest"),
    DevOutput: () => import("@/views/dev/tools/DevOutput"),
    DevAuthRedirectUrl: () => import("@/views/dev/auth/DevAuthRedirectUrl"),
    DevAuthApplicationCredentials: () =>
      import("@/views/dev/auth/DevAuthApplicationCredentials"),
    DevAuth2Endpoint: () => import("@/views/dev/auth/DevAuth2Endpoint"),
    DevAuthSessionTokenExchange: () =>
      import("@/views/dev/auth/DevAuthSessionTokenExchange"),

    DevTriggerApiRequest: () =>
      import("@/views/dev/trigger/DevTriggerApiRequest"),
    DevActionInputTestRequest: () =>
      import("@/views/dev/action/DevActionInputTestRequest.vue"),
  },
  data() {
    return {
      menus: [],
      whichStep: [true, false, false, false, false],

      auths: [
        {
          name: "api",
          viewFile: [
            "DevAuthInputFields",
            "DevAuthInputTestRequest",
            "DevAuthInputTest",
          ],
          koreanText: ["필드 구성하기", "Request 테스트 구성하기", "테스트"],
        },
        {
          name: "oauth",
          viewFile: [
            "DevAuthInputFields",
            "DevAuthRedirectUrl",
            "DevAuthApplicationCredentials",
            "DevAuth2Endpoint",
            "DevAuthInputTest",
          ],
          koreanText: [
            "필드 구성하기",
            "Redirect Url 구성하기",
            "Credentials 입력하기",
            "Request 테스트 구성하기",
            "테스트",
          ],
        },
        {
          name: "session",
          viewFile: [
            "DevAuthInputFields",
            "DevAuthSessionTokenExchange",
            "DevAuthInputTestRequest",
            "DevAuthInputTest",
          ],
          koreanText: [
            "필드 구성하기",
            "세션 토큰 설정하기",
            "Request 테스트 구성하기",
            "테스트",
          ],
        },
        {
          name: "basic",
          viewFile: ["DevAuthInputTestRequest", "DevAuthInputTest"],
          koreanText: ["Request 테스트 구성하기", "테스트"],
        },
        {
          name: "digist",
          viewFile: [
            "DevAuthInputFields",
            "DevAuthInputTestRequest",
            "DevAuthInputTest",
          ],
          koreanText: ["필드 추가하기", "Request 테스트 구성하기", "테스트"],
        },
      ],
      triggers: [
        {
          name: "one",
          viewFile: ["DevTriggerApiRequest", "DevAuthInputTest", "DevOutput"],
          koreanText: ["Request 구성하기", "테스트", "아웃풋 설정"],
        },
      ],
      actions: [
        {
          name: "one",
          viewFile: [
            "DevActionInputTestRequest",
            "DevAuthInputTest",
            "DevOutput",
          ],
          koreanText: ["Request 구성하기", "테스트", "아웃풋 설정"],
        },
      ],

      acts: ["testRequest", "test"],
      modalClick: false,
      forms: [],
      modalDisabled: true,
    }
  },
  methods: {
    changeStatus(num) {
      this.whichStep[num] = !this.whichStep[num];
      this.whichStep.push();
    },

    cloneSave() {
      this.modalDisabled = true;
      console.log(this.modalDisabled)

      console.log("formList: ", this.forms);

      var final = new Map();
      if (this.forms.length > 0) {
        for (var i = 0; i < this.forms.length; i++) {
          final.set(this.forms[i].key, this.forms[i].value);
        }
      }
      final.set("index", this.forms.length);

      var date = new Date();
      var yyyy = date.getFullYear();
      var mm =
        Number(date.getMonth()) + Number(1) > 9
          ? Number(date.getMonth()) + Number(1)
          : "0" + (Number(date.getMonth()) + Number(1));
      var dd = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();

      var today = yyyy + "-" + mm + "-" + dd;

      final.set("insertDt", today);

      console.log(final);

      var apiCode = this.$store.state.devStore.apiAuth[0].apiCode;

      var param = {
        appCode: this.$store.state.devStore.appCode,
        apiCode: apiCode,
        versionCode: this.$store.state.devStore.apiData.versionCode,

        paramData: JSON.stringify(Object.fromEntries(final)),
      };

      this.api.addAuth(param)
        .then(() => {
          // console.log("테스트 데이터 : ", res);

          this.modalClick = false;

          this.$store
            .dispatch("apiDetail")
            .then(() => {
              eventbus.$emit("resetApiDetail");
            })
            .catch(() => alert("오류가 발생했습니다. modal"));
        })
        .catch(() => alert("오류가 발생했습니다. auth 2"));

      // this.modalClick = false
    },
    closeModal() {
      this.modalClick = false;
    },

    setFormsDatas() {
      console.log(this.$store.state.devStore.apiAuth);
      var apiCode = this.$store.state.devStore.apiAuth[0].apiCode;

      var param = {
        // appCode: this.$store.state.devStore.appCode,
        apiCode: apiCode,
        // versionCode : this.$store.state.devStore.apiData.versionCode

        // paramData : JSON.stringify(this.forms)
      };

      this.api.selectOneApi(param)
        .then((res) => {
          console.log("데이터 : ", res);

          // console.log(JSON.parse(res.api.apiSchema).design.forms)
          // this.forms = JSON.parse(res.api.apiSchema).design.forms

          this.forms = [];

          var formform = [];
          // if(this.$store.state.devStore.formsData != null){
          for (
            var i = 0;
            i < JSON.parse(res.api.apiSchema).design.forms.length;
            i++
          ) {
            // console.log(JSON.parse(res.api.apiSchema).design.forms[i])
            var list = new Object();

            list = {
              key: JSON.parse(res.api.apiSchema).design.forms[i].keys.replace(
                /"/gi,
                ""
              ),
              value: "",
            };
            formform.push(list);
          }

          this.forms = formform;
        })
        .catch(() => alert("오류가 발생했습니다. auth 2"));
    },
  },
  created() {
    console.log('DevAuthSetting created')
    eventbus.$on("openTestModal", () => {
      this.modalClick = true;
      this.modalDisabled = false;
      this.setFormsDatas();

      // if(this.$store.state.devStore.formsData != null){
      //   for(var  i = 0; i < this.$store.state.devStore.formsData.length; i++){
      //     console.log(this.$store.state.devStore.formsData[i])
      //     var list = new Object()

      //     list = {"key": this.$store.state.devStore.formsData[i].keys.replace(/"/gi, ""), "value": ""}
      //     this.forms.push(list)
      //   }
      // }

      // this.formList = list

      // document.getElementsByClassName('overlay')[0].style.display = "block"
    });


    console.log("created", this.$store.state.devStore.apiAuth);
    console.log("created", this.$store.state.devStore.apiData);
    var type = this.$store.state.devStore.apiData.apiType.replace(/"/gi, "");
    var name = this.$store.state.devStore.apiData.apiName.replace(/"/gi, "");

    console.log("타입이름 : ",type, name)

    //   this.checkType = this.$route.params.checkType;

    // this.checkName = name

    if (type == "authentication" && name == "Api Key") {
      this.menus = this.auths[0];
    } else if (type == "authentication" && name == "OAuth2") {
      this.menus = this.auths[1];
    } else if (type == "authentication" && name == "Auth Session") {
      this.check = "session";
      this.menus = this.auths[2];
    } else if (type == "authentication" && name == "Basic Auth") {
      //이거 뭐였지?
      this.menus = this.auths[3];
    } else if (type == "authentication" && name == "Digest Auth") {
      this.menus = this.auths[4];
    } else if (type == "trigger") {
      //   this.checkType = this.menuType;

      this.menus = this.triggers[0];
      // this.menus.push()
      console.log(this.menus, "Triggers");
    } else if (type == "action") {
      //   this.checkType = this.menuType;

      this.menus = this.actions[0];
      // this.menus.push()
      console.log(this.menus, "Actions");
    }
  },
  mounted() {
    console.log('DevAuthSetting created')
  },
  beforeDestroy() {
    console.log('DevAuthSetting beforeDestroy')
    eventbus.$off("method");
    eventbus.$off("url");
    eventbus.$off("param");
    eventbus.$off("headers");
    eventbus.$off("body");
    eventbus.$off("sendCodeDatas");
    eventbus.$off("sendCodeDatasTrueFalse");
  }
}
</script>

